import ninegrid from "../index.js";
import {nxDiv} from "./_nxDiv.js";

class nxButtons extends nxDiv {

	constructor() {
		super();
	}

	connectedCallback() {
		if (super.connectedCallback()) this.#init();
	};

	#init = () => {

		const htmlTmpl = document.createElement("template");
		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxButtons.css";
				${ninegrid.getCustomPath(this,"nxButtons.css")}
			</style>
            
            ${this.originContents}
        `;

		(this.shadowRoot || this).appendChild(htmlTmpl.content.cloneNode(true));
	}
}

if (!customElements.get('nx-buttons')) {
	customElements.define("nx-buttons", nxButtons);
}
